import React from 'react';
import './CloseClass.css';

function CloseClass() {
  return (
    <div className='CloseClass'>CloseClass</div>
  )
}

export default CloseClass